import { getMainDomain } from "./getMainDomain";

const DOMAIN_24HWEATHER = "24hweather.com";
const PRIVACY_POLICY_24HWEATHER = "https://www.24hweather.com/24hweather_privacy_policy.html";
const PRIVACY_POLICY_COMFORTWEATHER = "https://www.comfortweather.com/Privacy_Policy.html";
const PRIVACY_POLICY_MOBI321 = "https://wx.mobi321.com/wxmobi321com_privacy_policy.html";

export function getPrivacyPolicyUrl(): string {
  const domainType = getMainDomain();
  const { domain } = useSubdomain();

  return getMainDomain() === "mobi321.com" || domain === "wx.mobi321.com"
    ? PRIVACY_POLICY_MOBI321
    : domainType === DOMAIN_24HWEATHER
    ? PRIVACY_POLICY_24HWEATHER
    : PRIVACY_POLICY_COMFORTWEATHER;
}
